module.exports = __webpack_public_path__ + "img/app-item-error-dark.95bd9dfb.svg";